import React, { createContext, useContext, useState } from "react";

const ContentContext = createContext();

export function ContentProvider({ children }) {
  const [contentData, setContentData] = useState({
    shop: "",
    tone: "",
    language: "",
    content_type: "",
    sample_text: "",
    keywords: "",
    product_url: "",
  });

  return (
    <ContentContext.Provider value={{ contentData, setContentData }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);